import { Box, darkColors, useColorModeValue as mode } from '@chaine/keychaine';
import React from 'react';
export const StyledBox = ({ children, ...props }) => {
    return (React.createElement(Box, { overflow: "hidden", _hover: { cursor: 'pointer' }, bg: mode('white', darkColors.gray[700]), rounded: "xl", shadow: mode('xl', 'dark-lg'), borderColor: mode(props.borderColorProps?.light || 'gray.100', props.borderColorProps?.dark || 'gray.700'), borderWidth: "2px", py: 3, ...props }, children));
};
